var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import { Progress as ChakraProgress, } from "@chakra-ui/react";
/**
 * Progress is used to display the progress status for a task that takes a long time or consists of several steps.
 */
const Progress = forwardRef((_a, ref) => {
    var { className } = _a, rest = __rest(_a, ["className"]);
    return (React.createElement(ChakraProgress, Object.assign({ className: className, ref: ref }, rest)));
});
Progress.displayName = "Progress";
export default Progress;
//# sourceMappingURL=Progress.js.map